import { render, staticRenderFns } from "./rIndex.vue?vue&type=template&id=4575db50&scoped=true&"
import script from "./rIndex.vue?vue&type=script&lang=js&"
export * from "./rIndex.vue?vue&type=script&lang=js&"
import style0 from "./rIndex.vue?vue&type=style&index=0&id=4575db50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4575db50",
  null
  
)

export default component.exports